'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _documentOffset = require('document-offset');

var _documentOffset2 = _interopRequireDefault(_documentOffset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var preventDefault = function preventDefault() {};
var stopPropagation = function stopPropagation() {};

var Main = function (_View) {
    _inherits(Main, _View);

    function Main(props) {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        _this.template = _main2.default;


        var collection = props.collection ? _this._processCollection(props.collection) : props.children;
        _this._preparedList = _this._prepareList(collection);

        _this.state = {
            verticalScroll: false,
            horizontalScroll: false,
            active: false,
            hover: false,
            direction: 'down',
            horizontalDirection: 'left',
            maxHeight: null,
            maxWidth: null,
            list: collection
        };

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var list = nextProps.collection ? this._processCollection(nextProps.collection) : nextProps.children;
            this._preparedList = this._prepareList(list);

            this.setState({ list: list }).then(function () {
                var selected = _this2._getSelected();

                if (_this2.props.value !== null && _this2.props.value !== undefined && _this2.props.value !== '' && !selected) {
                    _this2.value = null;
                }
            });

            return this;
        }
    }, {
        key: 'isUiActive',
        value: function isUiActive() {
            return this.state.active;
        }
    }, {
        key: '_getSelected',
        value: function _getSelected() {
            var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._preparedList;
            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.value;

            // без точного приведения типов, потому что в модель может записаться стринг после ввода через инпут
            return list.find(function (item) {
                return value == item.id;
            });
        }
    }, {
        key: 'open',
        value: function open() {
            var _this3 = this;

            if (this.props.readOnly || this.props.disabled) {
                return Promise.resolve();
            }

            if (this.isUiActive()) {
                return this.close();
            }

            if (this._preparedList.length) {
                this.docH = window.document.documentElement.offsetHeight;
                this.docW = window.document.documentElement.offsetWidth;

                this.setState({
                    active: true,
                    verticalScroll: this._preparedList.length > this.props.maxLength
                }).then(function () {
                    // firefox сбрасывает фокус почему то, нужно его вернуть что бы работала стрелочная навигация
                    _this3.nativeElement.focus();
                    _this3._setPosition();
                });
            }

            return Promise.resolve();
        }
    }, {
        key: '_handleBodyClick',
        value: function _handleBodyClick() {
            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (this.state.active && !this.root.contains(event.target)) {
                this.close();
            }

            return this;
        }

        /**
         * Обновляем позицию выпадающего списка
         * @return {Promise}
         */

    }, {
        key: '_setPosition',
        value: function _setPosition() {
            var listOffset = void 0,
                listH = this.list.offsetHeight,
                listW = this.list.offsetWidth,
                rootWidth = this.root.offsetWidth,
                rootHeight = this.root.offsetHeight,
                direction = 'down',
                horizontalDirection = 'left',
                maxWidth = null,
                maxHeight = null,
                availTop = void 0,
                availBottom = void 0,
                availRight = void 0,
                availLeft = void 0,
                verticalScroll = this.state.verticalScroll,
                horizontalScroll = this.state.horizontalScroll;

            listOffset = (0, _documentOffset2.default)(this.list);

            if (listOffset) {
                availTop = listOffset.top - rootHeight - 8;
                availBottom = this.docH - listOffset.top - 8;
                availLeft = listOffset.left + rootWidth - 8;
                // minimal padding + scroll
                availRight = this.docW - listOffset.left - 24;

                // вылазит на нижнюю границу документа
                if (availBottom < listH) {
                    var maxAvailHeight = void 0;

                    direction = availBottom > availTop ? 'down' : 'up';
                    maxAvailHeight = direction === 'down' ? availBottom : availTop;

                    // список не влазит по высоте ни в каком случае
                    if (listH > maxAvailHeight) {
                        maxHeight = maxAvailHeight + 'px';
                        verticalScroll = true;
                    }
                }

                // вылазит за правую границу документа
                if (availRight < listW) {
                    var maxAvailWidth = void 0;

                    horizontalDirection = availLeft > availRight ? 'right' : 'left';
                    maxAvailWidth = horizontalDirection === 'right' ? availLeft : availRight;

                    // по горизонтали не помещается ни в каком случае
                    if (listW > maxAvailWidth) {
                        maxWidth = maxAvailWidth + 'px';
                        horizontalScroll = true;
                    }
                }
            }

            return this.setState({
                direction: direction,
                horizontalDirection: horizontalDirection,
                maxWidth: maxWidth,
                maxHeight: maxHeight,
                horizontalScroll: horizontalScroll,
                verticalScroll: verticalScroll
            });
        }

        /**
         * event setter + events select handler
         * @param {string} value
         * @return {Promise}
         */

    }, {
        key: 'select',
        value: function select(value) {
            this.value = value;
            return this.close().then(function () {
                return Promise.resolve();
            });
        }
    }, {
        key: 'close',
        value: function close() {
            return this.setState({
                active: false,
                direction: 'down',
                horizontalDirection: 'left',
                maxHeight: null,
                maxWidth: null,
                horizontalScroll: false,
                verticalScroll: false
            });
        }
    }, {
        key: 'focusList',
        value: function focusList() {
            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';

            var items = this.list.querySelectorAll('[role="drop-item"]');

            if (position === 'first' && items.length) {
                items[0].focus();
            } else if (position === 'last' && items.length) {
                items[items.length - 1].focus();
            }

            return this;
        }
    }, {
        key: 'focus',
        value: function focus() {
            this.nativeElement.focus();
            return this;
        }
    }, {
        key: '_handleBlur',
        value: function _handleBlur(event) {
            var relatedTarget = void 0;

            // Firefox not supported relativeEvent
            if (event.relatedTarget !== null) {
                relatedTarget = event.relatedTarget;

                // hack for firefox. returns some like event.target, but more strict.
            } else if (event.nativeEvent && event.nativeEvent.explicitOriginalTarget) {
                relatedTarget = event.nativeEvent.explicitOriginalTarget;
            }

            // блюр срабатывает так же при выборе элемента из списка, в таком случае нам не нужна обработка введенных в инпут данных
            if (!this.root.contains(relatedTarget)) {
                this.close();
            }

            return this;
        }
    }, {
        key: '_keymap',
        value: function _keymap(event) {
            if (event.keyCode === 40 || event.keyCode === 38) {
                event.preventDefault();

                var items = this.list.querySelectorAll('[role="drop-item"]'),
                    focused = Array.prototype.find.call(items, function (node) {
                    return window.document.activeElement === node;
                }),
                    focusedIndex = Array.prototype.indexOf.call(items, focused);

                if (event.keyCode === 40) {
                    if (items.length && items[focusedIndex + 1]) {
                        items[focusedIndex + 1].focus();
                    } else if (items.length) {
                        items[0].focus();
                    }
                } else {
                    if (items.length && items[focusedIndex - 1]) {
                        items[focusedIndex - 1].focus();
                    } else if (items.length) {
                        items[items.length - 1].focus();
                    }
                }
            }

            return this;
        }

        /**
         * слушает keyDown на селекте для того что бы перенести фокус на список, если нажата стрелочка
         * @param {Object} event
         * @return {Object}
         * @private
         */

    }, {
        key: '_handleFocusList',
        value: function _handleFocusList() {
            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (event.keyCode === 40 || event.keyCode === 38) {
                event.preventDefault();

                this.focusList(event.keyCode === 40 ? 'first' : 'last');
            }

            return this;
        }
    }, {
        key: '_handleHover',
        value: function _handleHover() {
            return this.setState({ hover: true });
        }
    }, {
        key: '_handleRootBlur',
        value: function _handleRootBlur() {
            return this.setState({ hover: false });
        }
    }, {
        key: '_listRef',
        value: function _listRef(el) {
            this.list = el;
        }
    }, {
        key: '_rootRef',
        value: function _rootRef(el) {
            this.root = el;

            if (typeof this.props.elementRef === 'function') {
                this.props.elementRef(this);
            }
        }
    }, {
        key: '_nativeRef',
        value: function _nativeRef(el) {
            this.nativeElement = el;
        }
    }, {
        key: 'computeStyleHash',
        value: function computeStyleHash() {
            return _get(Main.prototype.__proto__ || Object.getPrototypeOf(Main.prototype), 'computeStyleHash', this).call(this) + String(this.props.disabled || this.props.readOnly) + String(this.state.active) + String(this.state.hover) + String(this.state.verticalScroll) + String(this.state.direction) + String(this.state.horizontalDirection) + String(this.state.maxWidth) + String(this.state.maxHeight) + String(this.props.inline) + String(this.props.error);
        }
    }, {
        key: 'value',
        get: function get() {
            return this.props.value;
        },
        set: function set(value) {
            var target = void 0,
                event = void 0;

            target = Object.assign({}, this, {
                value: value
            });

            event = {
                target: target,
                currentTarget: target,
                preventDefault: preventDefault,
                stopPropagation: stopPropagation,
                type: 'change'
            };

            if (typeof this.props.onChange === 'function') {
                this.props.onChange(event);
            }
        }
    }]);

    return Main;
}(_Component2.default);

Main.defaultProps = {
    // max length of list
    maxLength: 12,
    // placeholder for empty drop list
    emptyListPlaceholder: 'DROP_EMPTY_LIST',
    // components label
    label: '',
    // components placeholder
    placeholder: 'DROP_DEFAULT',
    inline: false
};
Main.propTypes = {
    // max length of list
    maxLength: _propTypes2.default.number,
    // placeholder for empty drop list
    emptyListPlaceholder: _propTypes2.default.string,
    // components label
    label: _propTypes2.default.string,
    // components placeholder
    placeholder: _propTypes2.default.string,
    // processor fn
    processor: _propTypes2.default.func,
    // onChange callback
    onChange: _propTypes2.default.func,
    // inline style
    inline: _propTypes2.default.bool,
    collection: _propTypes2.default.any
};
Main.displayName = 'DropDown';
exports.default = Main;